import municipalityReducer from './municipalitySlice';
import * as municipalityActions from './actions';
import * as municipalitySelector from './selector';

export {
  municipalityActions,
  municipalitySelector
}

export default municipalityReducer